export const PlaceholderImage = () => <img src="http://placehold.it/198x145" alt="" />;
